'use client'

import ServerSideLoaded from '@/components/pages/LandingPage/Homepage/server-side-loaded'
import nextDynamic from 'next/dynamic'
// import PricingModule fro
const ClientSideLoaded = nextDynamic(() => import('@/components/pages/LandingPage/Homepage/client-side-loaded'))
import { getUTMDataFromCookies, getUserAgent, type UTMParams } from '@/lib/utm-utils';

// Define the headline and subheadline props for HTMA-639
const htma639Props = {
  // Server-side props
  heroTabbed: {
    title: "Deep work communication system for remote teams.",
    subtitle: "Turn communication chaos into deep work: one inbox for tasks, threads, and AI summaries so you ship in long, focused blocks",
  },
  heroHomepage: {
    title: "Deep work communication system for remote teams.",
    subtitle: "Turn communication chaos into deep work: one inbox for tasks, threads, and AI summaries so you ship in long, focused blocks",
  },
  // Client-side props
  hyperAI: {
    title: "HyperAI - Your silent teammate for async work.",
    subtitle: "The deep work system with an AI teammate built in - HyperAI batches updates, preserves context, and helps your team stay in flow while moving faster together."
  },
  taskWriter: {
    title: "AI Task Writer: Async work, accelerated.",
    subtitle: "Hypertask <b>learns your projects</b>, so every ticket is context-aware.<br/>Describe briefly what you need and get clear, detailed tasks instantly."
  },
  inbox: {
    title: "The deep work communication system for teams who build",
    subtitle: "One inbox. Zero interruptions. Pure focus."
  },
  aiModels: {
    title: "One Workspace. All the AIs.",
    subtitle: "Choose from the best AI models for your workflow"
  },
  dictation: {
    title: "Ultra-accurate voice-to-text built in.",
    subtitle: "Just talk. Hypertask captures your thoughts, even in chaos hands-free, multilingual, and instant."
  },
  dictateAndImprove: {
    title: "Dictate and improve with AI.",
    subtitle: "Dictate async updates in seconds — Hypertask's AI refines them<br/>into polished, readable communication."
  },
  pricing: {
    title: "Pricing for teams that value focus over noise."
  },
  timeSavings: {
    title: "AI-powered workflow saves 4+ hours weekly",
    subtitle: "See how Hypertask's AI features transform every project management task"
  },

  aiComparisonTable: {
    title: "Precision AI Features To Accelerate Async Comms.",
    subtitle: "Turn chaos into clarity. Everything you need for deep work lives in one place."
  },

}

function HomePageContent() {
  const utmData = getUTMDataFromCookies();
  console.log('🚀 ~ utmData:', utmData)
  const userAgent = getUserAgent();
  console.log('🚀 ~ userAgent:', userAgent)
  return (
    <>
      <ServerSideLoaded
        heroTabbedTitle={htma639Props.heroTabbed.title}
        heroTabbedSubtitle={htma639Props.heroTabbed.subtitle}
        heroHomepageTitle={htma639Props.heroHomepage.title}
        heroHomepageSubtitle={htma639Props.heroHomepage.subtitle}
        aiComparisonTableTitle={htma639Props.aiComparisonTable.title}
        aiComparisonTableSubtitle={htma639Props.aiComparisonTable.subtitle}
      />
      <ClientSideLoaded
        hyperAITitle={htma639Props.hyperAI.title}
        hyperAISubtitle={htma639Props.hyperAI.subtitle}
        taskWriterTitle={htma639Props.taskWriter.title}
        taskWriterSubtitle={htma639Props.taskWriter.subtitle}
        inboxTitle={htma639Props.inbox.title}
        inboxSubtitle={htma639Props.inbox.subtitle}
      />
    </>
  )
}

export default function HomePage() {
  return (
    <HomePageContent />
  )
}